import React from 'react';
import createReactClass from 'create-react-class';

import PropTypes from 'prop-types';
// import ReactDom from 'react-dom';
import tweenState from 'kw-react-tween-state';
import assign from 'object-assign';
import ExecutionEnvironment from 'exenv';
import decorators from './Decorators';

const addEvent = function(elem, type, eventHandle) {
  if (elem === null || typeof elem === 'undefined') {
    return;
  }
  if (elem.addEventListener) {
    elem.addEventListener(type, eventHandle, false);
  } else if (elem.attachEvent) {
    elem.attachEvent(`on${type}`, eventHandle);
  } else {
    elem[`on${type}`] = eventHandle;
  }
};

const removeEvent = function(elem, type, eventHandle) {
  if (elem === null || typeof elem === 'undefined') {
    return;
  }
  if (elem.removeEventListener) {
    elem.removeEventListener(type, eventHandle, false);
  } else if (elem.detachEvent) {
    elem.detachEvent(`on${type}`, eventHandle);
  } else {
    elem[`on${type}`] = null;
  }
};

const Carousel = createReactClass({
  displayName: 'Carousel',
  mixins: [tweenState.Mixin],
  propTypes: {
    afterSlide: PropTypes.func,
    autoplay: PropTypes.bool,
    autoplayInterval: PropTypes.number,
    beforeSlide: PropTypes.func,
    cellAlign: PropTypes.oneOf(['left', 'center', 'right']),
    cellSpacing: PropTypes.number,
    data: PropTypes.func,
    decorators: PropTypes.arrayOf(
      PropTypes.shape({
        component: PropTypes.func,
        position: PropTypes.oneOf([
          'TopLeft',
          'TopCenter',
          'TopRight',
          'CenterLeft',
          'CenterCenter',
          'CenterRight',
          'BottomLeft',
          'BottomCenter',
          'BottomRight',
        ]),
        style: PropTypes.object,
      }),
    ),
    dragging: PropTypes.bool,
    easing: PropTypes.string,
    edgeEasing: PropTypes.string,
    framePadding: PropTypes.string,
    frameOverflow: PropTypes.string,
    heightMode: PropTypes.oneOf(['max', 'adaptive']).isRequired,
    initialSlideHeight: PropTypes.number,
    initialSlideWidth: PropTypes.number,
    lazyLoad: PropTypes.bool,
    slideIndex: PropTypes.number,
    slidesToShow: PropTypes.number,
    slidesToScroll: PropTypes.oneOfType([
      PropTypes.number,
      PropTypes.oneOf(['auto']),
    ]),
    slideWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    speed: PropTypes.number,
    vertical: PropTypes.bool,
    width: PropTypes.string,
    wrapAround: PropTypes.bool,
  },

  getDefaultProps() {
    return {
      afterSlide() {},
      autoplay: false,
      autoplayInterval: 3000,
      beforeSlide() {},
      cellAlign: 'left',
      cellSpacing: 0,
      data() {},
      decorators,
      dragging: true,
      easing: 'easeOutCirc',
      edgeEasing: 'easeOutElastic',
      framePadding: '0px',
      frameOverflow: 'hidden',
      heightMode: 'max',
      slideIndex: 0,
      slidesToScroll: 1,
      slidesToShow: 1,
      slideWidth: 1,
      speed: 500,
      vertical: false,
      width: '100%',
      wrapAround: false,
      name: '',
    };
  },

  getInitialState() {
    return {
      currentSlide: this.props.slideIndex,
      dragging: false,
      frameWidth: 0,
      left: 0,
      slideCount: 0,
      slidesToScroll: this.props.slidesToScroll,
      slideWidth: 0,
      top: 0,
    };
  },

  UNSAFE_componentWillMount() {
    this.setInitialDimensions();
  },

  componentDidMount() {
    this.getListStyles();
    this.setDimensions();
    this.bindEvents();
    this.setExternalData(0);
    if (this.props.autoplay) {
      this.startAutoplay();
    }
    setTimeout(() => {
      this.setDimensions();
    }, 2000);
  },

  UNSAFE_componentWillReceiveProps(nextProps) {
    this.setState({
      slideCount: nextProps.realSize,
    });

    this.setDimensions(nextProps);
    if (
      this.props.slideIndex !== nextProps.slideIndex &&
      nextProps.slideIndex !== this.state.currentSlide
    ) {
      this.goToSlide(nextProps.slideIndex);
    }
    if (this.props.autoplay !== nextProps.autoplay) {
      if (nextProps.autoplay) {
        this.startAutoplay();
      } else {
        this.stopAutoplay();
      }
    }
  },

  componentWillUnmount() {
    this.unbindEvents();
    this.stopAutoplay();
  },

  calculateViewPort() {
    // if(this.state.innerWidth !== window.innerWidth) {
    const caja = this.state.slideWidth + this.props.cellSpacing; // .replace('px','')
    // calcula la relacion entre el tamaño de la caja y el viewport
    let viewporthWidth = window.innerWidth / (caja * this.state.slideCount);

    if (
      this.props.type === 'carrouseldoble' &&
      this.props.nombre === 'carrouselizq'
    ) {
      viewporthWidth = caja / (caja * this.state.slideCount);
    } else {
      viewporthWidth = window.innerWidth / (caja * this.state.slideCount);
    }

    this.state.innerWidth = window.innerWidth;
    this.state.viewporthWidth = viewporthWidth;
    // }

    return this.state.viewporthWidth;
  },

  render() {
    const self = this;
    const children =
      React.Children.count(this.props.children) > 1
        ? this.formatChildren(this.props.children)
        : this.props.children;
    const viewporthWidth = this.calculateViewPort();

    return (
      <div
        className={['slider', this.props.className || ''].join(' ')}
        ref="slider"
        style={assign(this.getSliderStyles(), this.props.style || {})}
      >
        <div
          className="slider-frame"
          ref="frame"
          style={this.getFrameStyles()}
          {...this.getTouchEvents()}
          {...this.getMouseEvents()}
          onClick={this.handleClick}
        >
          <ul className="slider-list" ref="list" style={this.getListStyles()}>
            {children}
          </ul>
        </div>
        {/* y si la relacion sobrante es menor a 1 pintamos flechitas */}
        {this.props.decorators && viewporthWidth < 1
          ? this.props.decorators.map((Decorator, index) => (
            <div
              style={assign(
                self.getDecoratorStyles(Decorator.position),
                Decorator.style || {},
              )}
              className={`slider-decorator-${index}`}
              key={index}
            >
              <Decorator.component
                currentSlide={self.state.currentSlide}
                slideCount={self.state.slideCount}
                frameWidth={self.state.frameWidth}
                slideWidth={self.state.slideWidth}
                slidesToScroll={self.state.slidesToScroll}
                cellSpacing={self.props.cellSpacing}
                slidesToShow={self.props.slidesToShow}
                wrapAround={self.props.wrapAround}
                nextSlide={self.nextSlide}
                previousSlide={self.previousSlide}
                goToSlide={self.goToSlide}
                type={self.props.type}
                nombre={self.props.nombre}
              />
            </div>
          ))
          : null}
        <style
          type="text/css"
          dangerouslySetInnerHTML={{ __html: self.getStyleTagStyles() }}
        />
      </div>
    );
  },

  // Touch Events

  touchObject: {},

  getTouchEvents() {
    const self = this;

    return {
      onTouchStart(e) {
        self.touchObject = {
          startX: e.touches[0].pageX,
          startY: e.touches[0].pageY,
        };
        self.setState(
          { swipeStart: new Date().getTime() },
          self.handleMouseOver,
        );
      },
      onTouchMove(e) {
        const direction = self.swipeDirection(
          self.touchObject.startX,
          e.touches[0].pageX,
          self.touchObject.startY,
          e.touches[0].pageY,
        );

        if (direction !== 0) {
          e.preventDefault();
        }

        const length = self.props.vertical
          ? Math.round(
            Math.sqrt(
              Math.pow(e.touches[0].pageY - self.touchObject.startY, 2),
            ),
          )
          : Math.round(
            Math.sqrt(
              Math.pow(e.touches[0].pageX - self.touchObject.startX, 2),
            ),
          );

        self.touchObject = {
          startX: self.touchObject.startX,
          startY: self.touchObject.startY,
          endX: e.touches[0].pageX,
          endY: e.touches[0].pageY,
          length,
          direction,
        };

        self.setState({
          left: self.props.vertical
            ? 0
            : self.getTargetLeft(
              self.touchObject.length * self.touchObject.direction,
            ),
          top: self.props.vertical
            ? self.getTargetLeft(
              self.touchObject.length * self.touchObject.direction,
            )
            : 0,
        });
      },
      onTouchEnd(e) {
        const delta = new Date().getTime() - self.state.swipeStart;
        const endX = parseFloat(self.touchObject.endX);
        const startX = parseFloat(self.touchObject.startX);
        const distance = endX < startX ? startX - endX : endX - startX;
        const speed = ((distance / window.innerWidth) * 100 * 6) / delta;
        const move = Math.min(Math.ceil(speed), 6);

        self.setState({ move }, () => {
          self.handleSwipe();
          self.handleMouseOut();
        });
      },
      onTouchCancel(e) {
        self.handleSwipe(e);
      },
    };
  },

  clickSafe: true,

  getMouseEvents() {
    const self = this;

    if (this.props.dragging === false) {
      return null;
    }

    return {
      onMouseOver() {
        self.handleMouseOver();
      },
      onMouseOut() {
        self.handleMouseOut();
      },
      onMouseDown(e) {
        self.touchObject = {
          startX: e.clientX,
          startY: e.clientY,
        };

        self.setState({
          dragging: true,
        });
      },
      onMouseMove(e) {
        if (!self.state.dragging) {
          return;
        }

        const direction = self.swipeDirection(
          self.touchObject.startX,
          e.clientX,
          self.touchObject.startY,
          e.clientY,
        );

        if (direction !== 0) {
          e.preventDefault();
        }

        const length = self.props.vertical
          ? Math.round(
            Math.sqrt(Math.pow(e.clientY - self.touchObject.startY, 2)),
          )
          : Math.round(
            Math.sqrt(Math.pow(e.clientX - self.touchObject.startX, 2)),
          );

        self.touchObject = {
          startX: self.touchObject.startX,
          startY: self.touchObject.startY,
          endX: e.clientX,
          endY: e.clientY,
          length,
          direction,
        };

        self.setState({
          left: self.props.vertical
            ? 0
            : self.getTargetLeft(
              self.touchObject.length * self.touchObject.direction,
            ),
          top: self.props.vertical
            ? self.getTargetLeft(
              self.touchObject.length * self.touchObject.direction,
            )
            : 0,
        });
      },
      onMouseUp(e) {
        if (!self.state.dragging) {
          return;
        }

        self.handleSwipe(e);
      },
      onMouseLeave(e) {
        if (!self.state.dragging) {
          return;
        }

        self.handleSwipe(e);
      },
    };
  },

  handleMouseOver() {
    if (this.props.autoplay) {
      this.autoplayPaused = true;
      this.stopAutoplay();
    }
  },

  handleMouseOut() {
    if (this.props.autoplay && this.autoplayPaused) {
      this.startAutoplay();
      this.autoplayPaused = null;
    }
  },

  handleClick(e) {
    if (this.clickSafe === true) {
      e.preventDefault();
      e.stopPropagation();

      if (e.nativeEvent) {
        e.nativeEvent.stopPropagation();
      }
    }
  },

  handleSwipe(e) {
    if (
      typeof this.touchObject.length !== 'undefined' &&
      this.touchObject.length > 44
    ) {
      this.clickSafe = true;
    } else {
      this.clickSafe = false;
    }

    let slidesToShow = this.props.slidesToShow;
    if (this.props.slidesToScroll === 'auto') {
      slidesToShow = this.state.slidesToScroll;
    }

    if (this.touchObject.length > this.state.slideWidth / slidesToShow / 5) {
      if (this.touchObject.direction === 1) {
        if (
          this.state.currentSlide >=
            React.Children.count(this.props.children) - slidesToShow &&
          !this.props.wrapAround
        ) {
          this.animateSlide(tweenState.easingTypes[this.props.edgeEasing]);
        } else {
          this.nextSlide();
        }
      } else if (this.touchObject.direction === -1) {
        if (this.state.currentSlide <= 0 && !this.props.wrapAround) {
          this.animateSlide(tweenState.easingTypes[this.props.edgeEasing]);
        } else {
          this.previousSlide();
        }
      }
    } else {
      this.goToSlide(this.state.currentSlide);
    }

    this.touchObject = {};

    this.setState({
      dragging: false,
    });
  },

  swipeDirection(x1, x2, y1, y2) {
    let xDist;
    let yDist;
    let r;
    let swipeAngle;

    xDist = x1 - x2;
    yDist = y1 - y2;
    r = Math.atan2(yDist, xDist);

    swipeAngle = Math.round((r * 180) / Math.PI);
    if (swipeAngle < 0) {
      swipeAngle = 360 - Math.abs(swipeAngle);
    }
    if (swipeAngle <= 45 && swipeAngle >= 0) {
      return 1;
    }
    if (swipeAngle <= 360 && swipeAngle >= 315) {
      return 1;
    }
    if (swipeAngle >= 135 && swipeAngle <= 225) {
      return -1;
    }
    if (this.props.vertical === true) {
      if (swipeAngle >= 35 && swipeAngle <= 135) {
        return 1;
      }
      return -1;
    }
    return 0;
  },

  autoplayIterator() {
    if (this.props.wrapAround) {
      return this.nextSlide();
    }
    if (
      this.state.currentSlide !==
      this.state.slideCount - this.state.slidesToShow
    ) {
      this.nextSlide();
    } else {
      this.stopAutoplay();
    }
  },

  startAutoplay() {
    this.autoplayID = setInterval(
      this.autoplayIterator,
      this.props.autoplayInterval,
    );
  },

  resetAutoplay() {
    if (this.props.autoplay && !this.autoplayPaused) {
      this.stopAutoplay();
      this.startAutoplay();
    }
  },

  stopAutoplay() {
    this.autoplayID && clearInterval(this.autoplayID);
  },

  // Action Methods

  goToSlide(index, toScroll = 1) {
    const self = this;
    this.setState(
      {
        currentSlide: index,
        prevSlide: this.state.currentSlide,
      },
      function() {
        self.animateSlide(
          null,
          null,
          null,
          () => {
            self.resetAutoplay();
            self.setExternalData(index);
            this.setState({ move: 1 });
          },
          toScroll,
        );
        self.props.afterSlide(index);
      },
    );
  },

  nextSlide() {
    const childrenCount = React.Children.count(this.props.children);
    let slidesToShow = this.props.slidesToShow;

    const toScroll = this.state.move || this.props.slidesToScroll;

    if (this.props.slidesToScroll === 'auto') {
      slidesToShow = toScroll;
    }
    if (
      this.state.currentSlide >= childrenCount - slidesToShow &&
      !this.props.wrapAround
    ) {
      return;
    }

    if (this.props.wrapAround) {
      const next = this.state.currentSlide + toScroll;
      const diff = next - this.state.slideCount;
      const goTo = next < this.state.slideCount ? next : diff;
      this.goToSlide(goTo, toScroll);
    } else {
      if (this.props.slideWidth !== 1) {
        return this.goToSlide(this.state.currentSlide + toScroll, toScroll);
      }
      this.goToSlide(
        Math.min(
          this.state.currentSlide + toScroll,
          childrenCount - slidesToShow,
        ),
        toScroll,
      );
    }
  },

  previousSlide() {
    const toScroll = this.state.move || this.props.slidesToScroll;

    if (this.state.currentSlide <= 0 && !this.props.wrapAround) {
      return;
    }

    if (this.props.wrapAround) {
      let goTo = this.state.currentSlide - toScroll;
      const diff = this.state.slideCount + goTo;
      goTo = goTo < 0 ? diff : goTo;
      this.goToSlide(goTo, toScroll);
    } else {
      this.goToSlide(Math.max(0, this.state.currentSlide - toScroll), toScroll);
    }
  },

  // Animation

  animateSlide(easing, duration, endValue, callback, toScroll) {
    const self = this;
    const begin = this.getBeginTarget(toScroll);

    const realDuration =
      toScroll === 1
        ? duration || this.props.speed
        : (duration || this.props.speed) * toScroll * 1.3;

    if (begin) {
      this.tweenState(this.props.vertical ? 'top' : 'left', {
        easing: easing || tweenState.easingTypes[this.props.easing],
        duration: 0,
        endValue: begin,
        onEnd: () => {
          self.tweenState(self.props.vertical ? 'top' : 'left', {
            easing: easing || tweenState.easingTypes[self.props.easing],
            duration: realDuration,
            endValue: endValue || self.getTargetLeft(),
            onEnd: callback || null,
          });
        },
      });
    } else {
      this.tweenState(this.props.vertical ? 'top' : 'left', {
        easing: easing || tweenState.easingTypes[this.props.easing],
        duration: realDuration,
        endValue: endValue || this.getTargetLeft(),
        onEnd: callback || null,
      });
    }
  },

  getBeginTarget(toScroll) {
    const change = this.state.currentSlide - this.state.prevSlide;

    if (Math.abs(change) > toScroll) {
      // const size = parseInt(this.props.slideWidth) + parseInt(this.props.cellSpacing)
      const offset = -1 * (change < 0 ? -1 : parseInt(this.state.slideCount));
      return offset * parseInt(this.state.slideWidth + this.props.cellSpacing);
    }

    return null;
  },

  getTargetLeft(touchOffset, slide) {
    let offset;
    const target = slide || this.state.currentSlide;
    switch (this.props.cellAlign) {
      case 'left': {
        offset = 0;
        offset -= this.props.cellSpacing * target;
        break;
      }
      case 'center': {
        offset = (this.state.frameWidth - this.state.slideWidth) / 2;
        offset -= this.props.cellSpacing * target;
        break;
      }
      case 'right': {
        offset = this.state.frameWidth - this.state.slideWidth;
        offset -= this.props.cellSpacing * target;
        break;
      }
    }

    let left = this.state.slideWidth * target;

    const lastSlide =
      this.state.currentSlide > 0 &&
      target + this.state.slidesToScroll >= this.state.slideCount;

    if (
      lastSlide &&
      this.props.slideWidth !== 1 &&
      !this.props.wrapAround &&
      this.props.slidesToScroll === 'auto'
    ) {
      left =
        this.state.slideWidth * this.state.slideCount - this.state.frameWidth;
      offset = 0;
      offset -= this.props.cellSpacing * (this.state.slideCount - 1);
    }

    offset -= touchOffset || 0;

    return (left - offset) * -1;
  },

  // Bootstrapping

  bindEvents() {
    const self = this;
    if (ExecutionEnvironment.canUseDOM) {
      addEvent(window, 'resize', self.onResize);
      addEvent(document, 'readystatechange', self.onReadyStateChange);
    }
  },

  onResize() {
    this.setDimensions();
  },

  onReadyStateChange() {
    this.setDimensions();
  },

  unbindEvents() {
    const self = this;
    if (ExecutionEnvironment.canUseDOM) {
      removeEvent(window, 'resize', self.onResize);
      removeEvent(document, 'readystatechange', self.onReadyStateChange);
    }
  },

  formatChildren(children) {
    const self = this;
    const positionValue = this.props.vertical
      ? this.getTweeningValue('top')
      : this.getTweeningValue('left');

    const start = Math.max(
      this.state.currentSlide - this.props.slidesToShow,
      0,
    );
    const end = Math.min(
      this.state.currentSlide + 2 * this.props.slidesToShow,
      this.state.slideCount,
    );

    return React.Children.map(children, (child, index) => {
      if (!self.props.lazyLoad || (start <= index && index < end)) {
        return (
          <li
            className="slider-slide"
            style={self.getSlideStyles(index, positionValue)}
            key={index}
          >
            {child}
          </li>
        );
      }
    });
  },

  setInitialDimensions() {
    const self = this;

    let slideWidth;

    let frameHeight;

    let slideHeight;
    slideWidth = this.props.vertical
      ? this.props.initialSlideHeight || 0
      : this.props.initialSlideWidth || 0;
    slideHeight = this.props.initialSlideHeight
      ? this.props.initialSlideHeight * this.props.slidesToShow
      : 0;

    frameHeight =
      slideHeight + this.props.cellSpacing * (this.props.slidesToShow - 1);

    this.setState(
      {
        slideHeight,
        frameWidth: this.props.vertical ? frameHeight : '100%',
        slideCount: React.Children.count(this.props.children),
        slideWidth,
      },
      () => {
        self.setLeft();
        self.setExternalData();
      },
    );
  },

  setDimensions(props) {
    props = props || this.props;

    const self = this;

    let slideWidth;

    let slidesToScroll;

    let frame;

    let frameWidth;

    let frameHeight;

    let slideHeight;

    let toScroll;

    slidesToScroll = props.slidesToScroll;

    frame = this.refs.frame;
    if (frame === undefined) {
      return false;
    }

    const slides = frame.childNodes[0].childNodes;

    if (this.props.vertical) {
      if (slides.length) {
        slides[0].style.height = 'auto';
        slideHeight = slides[0].offsetHeight * props.slidesToShow;
      } else {
        slideHeight = 100;
      }
    } else {
      slideHeight =
        (props.heightMode === 'max' && this.state.slideHeight) ||
        props.initialSlideHeight ||
        0;
      for (let i = 0; i < slides.length; i++) {
        // slideHeight = Math.max(slideHeight, slides[i].offsetHeight);
        slideHeight = slides[i].offsetHeight + 15;
      }
    }

    if (typeof props.slideWidth !== 'number') {
      slideWidth = parseInt(props.slideWidth);
    } else if (props.vertical) {
      slideWidth = (slideHeight / props.slidesToShow) * props.slideWidth;
    } else {
      slideWidth = (frame.offsetWidth / props.slidesToShow) * props.slideWidth;
    }

    if (!props.vertical) {
      slideWidth -=
        props.cellSpacing * ((100 - 100 / props.slidesToShow) / 100);
    }

    frameHeight = slideHeight + props.cellSpacing * (props.slidesToShow - 1);
    frameWidth = props.vertical ? frameHeight : frame.offsetWidth;

    if (props.slidesToScroll === 'auto') {
      toScroll = frameWidth / (slideWidth + props.cellSpacing);
      slidesToScroll =
        props.slideWidth === 1 ? Math.ceil(toScroll) : Math.floor(toScroll);
    }

    if (slides && slides[0]) {
      const firstImage = slides[0].getElementsByClassName('item-wrapper');
      if (
        firstImage &&
        firstImage[0] &&
        firstImage[0].clientWidth != 0 &&
        firstImage[0].clientHeight != 0
      ) {
        slideWidth = firstImage[0].clientWidth;
        slideHeight = firstImage[0].clientHeight;
      }
    }

    if (this.calculateViewPort() > 1) {
      this.goToSlide(0);
    }
    this.setState(
      {
        slideHeight,
        frameWidth,
        slideWidth,
        slidesToScroll,
        left: props.vertical ? 0 : this.getTargetLeft(),
        top: props.vertical ? this.getTargetLeft() : 0,
      },
      () => {
        self.setLeft();
      },
    );
  },

  setLeft() {
    this.setState({
      left: this.props.vertical ? 0 : this.getTargetLeft(),
      top: this.props.vertical ? this.getTargetLeft() : 0,
    });
  },

  // Data

  setExternalData(ops) {
    if (this.props.data) {
      this.props.data(ops);
    }
  },

  // Styles

  getListStyles() {
    const listWidth =
      this.state.slideWidth * React.Children.count(this.props.children);
    const spacingOffset =
      this.props.cellSpacing * React.Children.count(this.props.children);
    const transform = `translate3d(${this.getTweeningValue(
      'left',
    )}px, ${this.getTweeningValue('top')}px, 0)`;
    const styles = {
      transform,
      WebkitTransform: transform,
      msTransform: `translate(${this.getTweeningValue(
        'left',
      )}px, ${this.getTweeningValue('top')}px)`,
      position: 'relative',
      display: 'block',
      margin: this.props.vertical
        ? `${(this.props.cellSpacing / 2) * -1}px 0px`
        : `0px ${(this.props.cellSpacing / 2) * -1}px`,
      padding: '0px 0px 0px 3px',
      height: this.props.vertical
        ? listWidth + spacingOffset
        : this.state.slideHeight + 6,
      width: this.props.vertical ? 'auto' : listWidth + spacingOffset,
      cursor: this.state.dragging === true ? 'pointer' : 'inherit',
      boxSizing: 'border-box',
      MozBoxSizing: 'border-box',
    };

    if (this.props.customStyles && this.props.customStyles.width) {
      // styles = Object.assign(styles, this.props.customStyles);
      // debugger
    }

    return styles;
  },

  getFrameStyles() {
    return {
      position: 'relative',
      display: 'block',
      overflow: this.props.frameOverflow,
      height: this.props.vertical ? this.state.frameWidth || 'initial' : 'auto',
      margin: this.props.framePadding,
      padding: '0px 0px 0px 3px',
      transform: 'translate3d(0, 0, 0)',
      WebkitTransform: 'translate3d(0, 0, 0)',
      msTransform: 'translate(0, 0)',
      boxSizing: 'border-box',
      MozBoxSizing: 'border-box',
    };
  },

  getSlideStyles(index, positionValue) {
    const targetPosition = this.getSlideTargetPosition(index, positionValue);

    return {
      position: 'absolute',
      left: this.props.vertical ? 0 : targetPosition,
      top: this.props.vertical ? targetPosition : 0,
      display: this.props.vertical ? 'block' : 'inline-block',
      listStyleType: 'none',
      verticalAlign: 'top',
      width: this.props.vertical ? '100%' : this.state.slideWidth,
      height: 'auto',
      boxSizing: 'border-box',
      MozBoxSizing: 'border-box',
      marginLeft: this.props.vertical ? 'auto' : this.props.cellSpacing / 2,
      marginRight: this.props.vertical ? 'auto' : this.props.cellSpacing / 2,
      marginTop: this.props.vertical ? this.props.cellSpacing / 2 : 'auto',
      marginBottom: this.props.vertical ? this.props.cellSpacing / 2 : 'auto',
    };
  },

  getSlideTargetPosition(index, positionValue) {
    const slidesToShow = Math.ceil(
      this.state.frameWidth / this.state.slideWidth,
    );
    const totalWidth = this.state.slideWidth + this.props.cellSpacing;
    const targetPosition = totalWidth * index;
    const count = React.Children.count(this.props.children);

    const lastPosition = totalWidth * count;
    const isLastVisible =
      lastPosition < Math.abs(positionValue) + this.state.frameWidth;
    const isAtBegining = positionValue > 0;

    if (
      this.props.wrapAround &&
      (isLastVisible || isAtBegining) &&
      this.state.viewporthWidth < 1
    ) {
      const freeSpace =
        Math.abs(positionValue) + this.state.frameWidth - lastPosition;
      const slidesAfter = Math.ceil(freeSpace / totalWidth);

      if (index < slidesAfter) {
        return lastPosition + totalWidth * index;
      }

      if (isAtBegining && (index > count - 3 && index <= count - 1)) {
        return -(totalWidth * (count - index));
      }
    }

    return targetPosition;
  },

  getSliderStyles() {
    return {
      position: 'relative',
      display: 'block',
      width: this.props.width,
      height: 'auto',
      boxSizing: 'border-box',
      MozBoxSizing: 'border-box',
      visibility: this.state.slideWidth ? 'visible' : 'hidden',
    };
  },

  getStyleTagStyles() {
    return '.slider-slide > img {width: 100%; display: block;}';
  },

  getDecoratorStyles(position) {
    switch (position) {
      case 'TopLeft': {
        return {
          position: 'absolute',
          top: 0,
          left: 0,
        };
      }
      case 'TopCenter': {
        return {
          position: 'absolute',
          top: 0,
          left: '50%',
          transform: 'translateX(-50%)',
          WebkitTransform: 'translateX(-50%)',
          msTransform: 'translateX(-50%)',
        };
      }
      case 'TopRight': {
        return {
          position: 'absolute',
          top: 0,
          right: 0,
        };
      }
      case 'CenterLeft': {
        return {
          // position: 'absolute',
          // top: '50%',
          // left: 0,
          // transform: 'translateY(-50%)',
          // WebkitTransform: 'translateY(-50%)',
          // msTransform: 'translateY(-50%)'
        };
      }
      case 'CenterCenter': {
        return {
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%,-50%)',
          WebkitTransform: 'translate(-50%, -50%)',
          msTransform: 'translate(-50%, -50%)',
        };
      }
      case 'CenterRight': {
        return {
          // position: 'absolute',
          // top: '50%',
          // right: 0,
          // transform: 'translateY(-50%)',
          // WebkitTransform: 'translateY(-50%)',
          // msTransform: 'translateY(-50%)'
        };
      }
      case 'BottomLeft': {
        return {
          position: 'absolute',
          bottom: 0,
          left: 0,
        };
      }
      case 'BottomCenter': {
        return {
          position: 'absolute',
          bottom: 0,
          left: '50%',
          transform: 'translateX(-50%)',
          WebkitTransform: 'translateX(-50%)',
          msTransform: 'translateX(-50%)',
        };
      }
      case 'BottomRight': {
        return {
          position: 'absolute',
          bottom: 0,
          right: 0,
        };
      }
      default: {
        return {
          position: 'absolute',
          top: 0,
          left: 0,
        };
      }
    }
  },
});

Carousel.ControllerMixin = {
  getInitialState() {
    return {
      carousels: {},
    };
  },
  setCarouselData(carousel) {
    const data = this.state.carousels;
    data[carousel] = this.refs[carousel];
    this.setState({
      carousels: data,
    });
  },
};

export default Carousel;
